export const LANGUAGES = ['es', 'en', 'pt', 'fr'] as const

export type Language = (typeof LANGUAGES)[number]

export const DEFAULT_LANGUAGE: Language = 'es'

/**
 * Idioma de una ruta /:lang/slug. Las rutas sin idioma (/, /vecinos, /admin, un 404)
 * son del idioma por defecto, como al entrar en ellas directamente.
 */
export const languageFromPath = (pathname: string): Language => {
  const segmento = (pathname.split('/')[1] ?? '').toLowerCase()
  return (LANGUAGES as readonly string[]).includes(segmento) ? (segmento as Language) : DEFAULT_LANGUAGE
}
